import {MERCHANT_SORT_ORDER_UPDATED, MERCHANTS_FETCHED} from "./actionType";
import {Action} from "redux-actions";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import {MERCHANT_CREATED, MERCHANT_UPDATED} from "../merchant/actionType";
import Merchant from "../../../model/merchant/Merchant";

/**
 * merchants fetched successful action.
 * @param {Array<Merchant>} merchants all merchants from server.
 * @returns {Action<MERCHANTS_FETCHED>}
 */
function merchantsFetched(merchants: Array<Merchant>): Action<MERCHANTS_FETCHED> {
	return {type: MERCHANTS_FETCHED, payload: {merchants}};
}

/**
 * Merchant created successful action.
 * @return {Action<MERCHANT_CREATED>}
 * @param merchant
 */
function merchantCreated(merchant: Merchant): Action<MERCHANT_CREATED> {
	return {type: MERCHANT_CREATED, payload: {merchant}};
}

/**
 * Merchant updated successful action.
 * @return {Action<MERCHANT_UPDATED>}
 * @param merchant
 */
function merchantUpdated(merchant: Merchant): Action<MERCHANT_UPDATED> {
	return {type: MERCHANT_UPDATED, payload: {merchant}};
}

/**
 * Update merchants sort order successful action.
 * @return {Action<MERCHANT_SORT_ORDER_UPDATED>}
 * @param merchants
 */
function merchantsSortOrderUpdated(merchants: Array<Merchant>): Action<MERCHANT_SORT_ORDER_UPDATED> {
	return {type: MERCHANT_SORT_ORDER_UPDATED, payload: {merchants}};
}

/**
 * Fetch merchants from server.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchMerchants(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.merchantApi.fetchMerchants().then(merchants => {
			dispatch(merchantsFetched(merchants));
			onSuccess();
		}).catch(onFailure);
	};
}

/**
 * Create merchant.
 * @param merchant
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function createMerchant(merchant: Merchant, onSuccess: OnSuccessData<Merchant>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.merchantApi.createMerchant(merchant).then(m => {
			dispatch(merchantCreated(m));
			onSuccess(m);
		}).catch(onFailure);
	};
}

/**
 * Update merchant.
 * @param merchantId
 * @param merchant
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateMerchant(merchantId: string,
	merchant: Merchant,
	onSuccess: OnSuccessData<Merchant>,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.merchantApi.updateMerchant(merchantId, merchant).then(m => {
			dispatch(merchantUpdated(m));
			onSuccess(m);
		}).catch(onFailure);
	};
}

/**
 * Update merchant sort order.
 * @param merchants
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateMerchantsSortOrder(merchants: Merchant[],
	onSuccess: OnSuccess,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.merchantApi.updateSortOrder(merchants).then(() => {
			dispatch(merchantsSortOrderUpdated(merchants));
			onSuccess();
		}).catch(onFailure);
	};
}

